import * as jsxRuntime from "/Users/zhengwei/xinsulv/adsurgebot-FB-front-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment